import { createClient } from 'fets';
function AuthPlugin(provideFunc) {
    const getToken = async () => await provideFunc();
    return {
        async onRequestInit({ requestInit }) {
            const token = await getToken();
            requestInit.headers = {
                ...requestInit.headers,
                Authorization: `Bearer ${token}`
            };
        }
    };
}
const _createApiClient = (backendUrl, provideAuthTokenFunc) => {
    const apiClient = createClient({ endpoint: backendUrl, plugins: [AuthPlugin(provideAuthTokenFunc)] });
    return apiClient;
};
/**
 * Create a authenticated API client for the backend.
 */
export const createApiClient = (backendUrl, provideFunc) => {
    return _createApiClient(backendUrl, provideFunc);
};
export const getEditorInit = async (apiClient, courseId) => {
    const response = await apiClient['/api/editor/get-project/init/editor/{courseId}'].get({ params: { courseId } });
    if (response.status === 200) {
        return { isSuccess: true, data: await response.json() };
    }
    else if (response.status === 404) {
        return { isSuccess: false, reason: 'not found' };
    }
    else {
        return { isSuccess: false, reason: 'unknown' };
    }
};
export const addTourScene = async (apiClient, tourId, panoramaIds) => {
    const response = await apiClient['/api/tours/scenes/{tourId}'].post({
        params: { tourId: tourId },
        json: panoramaIds,
    });
    if (response.status === 200) {
        return { data: await response.json(), status: 200 };
    }
    else if (response.status === 409) {
        return { data: await response.json(), status: 409 };
    }
    else {
        return { data: null, status: 500 };
    }
};
export const getPreInitResponse = async (apiClient, viewMode, guid) => {
    const assertNever = (viewMode) => {
        throw Error('Unknown viewMode: ' + viewMode);
    };
    switch (viewMode) {
        case 'preview':
            return await apiClient['/api/editor/get-project/init/editor-preview/{courseGuid}'].get({ params: { courseGuid: guid } });
        case 'ael':
            return await apiClient['/api/editor/get-project/init/ael-student/{courseGuid}'].get({ params: { courseGuid: guid } });
        case 'public':
            return await apiClient['/api/editor/get-project/init/public/{guid}'].get({ params: { guid } });
        case 'scorm':
            return await apiClient['/api/editor/get-project/init/dispatched-scorm/{courseGuid}'].get({ params: { courseGuid: guid } });
        default:
            return assertNever(viewMode);
    }
};
